import { equals } from "lodash/fp"
import { distinctUntilChanged, map } from "rxjs"

import { getPrice$ } from "@/services/prices"

import { symbolBind } from "../TileContext"

export const [usePriceMovementData, priceMovement$] = symbolBind(
  (symbol: string) =>
    getPrice$(symbol).pipe(
      map(({ spread, movementType, symbol }) => {
        return { spread, movementType, symbol }
      }),
      distinctUntilChanged(equals),
    ),
)
